<template>
  <div v-if="addshow">
    <p style="padding: 0.4rem;text-align: center;font-size: 0.32rem;width: 1.6rem">快遞資訊</p>
    <md-field style="padding: 0 0.4rem">
      <md-input-item
        title="目的地"
        :value="whouse"
        readonly
      ></md-input-item>
      <md-input-item
        title="快遞單號"
        placeholder="請輸入快遞單號"
        v-model="num"
        @blur="queryLogisticsNameInfo"
      ></md-input-item>
      <div v-if="parceDetaik.isParcelType" @click="value=true">
        <md-input-item
          title="货物类型"
          :solid="false"
          v-model="parcelType"
          readonly
          class="ndnenr"
          placeholder="请选择"
        >
          <div slot="right" @click="value=true">
            <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.4rem"/>
          </div>
        </md-input-item>
        <div style="display: flex;border-bottom: 0.01rem solid #e2e4ea">
          <div style="width: 2.3rem"></div>
          <div style="font-size: 0.2rem;padding: 0.1rem 0;text-align: left;line-height: 0.4rem;color: #2a78dc">
            <span>{{ parceDetaik.text }}</span>
          </div>
        </div>
      </div>
      <div @click="handNoewe">
        <md-input-item
          title="生产销售企业"
          :solid="false"
          v-model="enterpriseName"
          readonly
          class="ndnenrdata"
          placeholder="请选择"
        >
        </md-input-item>
      </div>
      <div @click="handNoewe">
        <md-input-item
          title="生产销售企业代码"
          :solid="false"

          v-model="enterpriseCode"
          readonly
          class="ndnenrdata"
          placeholder="请选择"
        >
        </md-input-item>
      </div>

      <md-input-item
        title="企业订单"
        placeholder="請輸入企业订单"
        v-model="enterpriseOrder"
      ></md-input-item>

      <md-input-item
        title="包裹标注"
        placeholder="可对包裹标注，方便自己快速识别"
        v-model="remark"
      ></md-input-item>
      <md-field-item title="拆包" v-if="isParceldetail.isParcelUnpack">
        <div style="width: 100%;display: flex;justify-content: space-between" @click="value1=true">
          <span v-if="parcelUnpack">拆包发货</span>
          <span v-if="!parcelUnpack">不拆包发货</span>
          <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.4rem"/>
        </div>
        <!--        <md-switch v-model="parcelUnpack"  @change="cheurusner()"></md-switch>-->
      </md-field-item>
    </md-field>
    <p style="padding: 0.4rem 0.4rem 0 0.4rem;text-align: center;font-size: 0.32rem;width: 1.6rem">物品資訊</p>
    <div v-if="show" class="container">
      <md-icon name="wrong" class="icone" @click="show=false"></md-icon>
      <p>請您保留好貨物的商品發票，當貨物發生查驗或者需要提供發票時，將會郵件聯繫您提供商品發票，請悉知.</p>
    </div>
    <goodlist-modal ref="modal" @submitform="submitform"/>
    <div class="fils" v-if="conuntrycode.code=='JP'">
      <span>温馨提示：如物品中包含针织、皮革类物品请勾选。根据当地法规该类物品可能会被征收额外关税，如被查验需补齐相关税款。</span>
    </div>
    <md-action-sheet
      v-model="value"
      title="请选择货物类型"
      :cancel-text="cancelText"
      :options="options"
      @selected="$_selected"
    ></md-action-sheet>
    <md-action-sheet
      v-model="value1"
      title="请选择是否拆包发货"
      :cancel-text="cancelText"
      :options="optionstwo"
      @selected="$_selectedtwo"
    ></md-action-sheet>
  </div>
</template>

<script>
import {
  InputItem,
  Field,
  Icon,
  Stepper,
  FieldItem,
  Button,
  Toast,
  CheckList,
  ActionSheet,
  Switch,
  Dialog
} from 'mand-mobile'
import GoodlistModal from './Modal/GoodlistModal'
import eventBus from '../../until/eventBus'

export default {
  name: 'predition',
  components: {
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [FieldItem.name]: FieldItem,
    [Stepper.name]: Stepper,
    [CheckList.name]: CheckList,
    // eslint-disable-next-line vue/no-unused-components
    GoodlistModal
  },
  data() {
    return {
      favorites: [],
      value: false,
      value1: false,
      options: [
        {
          label: '普货',
          value: 0,
        },
        {
          label: '特货',
          value: 1,
        },
      ],
      optionstwo: [
        {
          label: '拆包发货',
          value: true,
        },
        {
          label: '不拆包发货',
          value: false,
        },
      ],
      defaultIndex: 1,
      invalidIndex: 2,
      cancelText: '取消',
      conuntrycode: {},
      addshow: false,
      show: false,
      parceDetaik: {
        isParcelType: false,
        text: ''
      },
      whouse: '',
      remark: '',
      fruits: [
        {
          value: 'apple',
          label: '如物品中包含針織、皮革類物品請勾選。根據當地法規該類物品可能會被徵收額外關稅，如被查驗需補齊相關稅款。',
        },
      ],
      expressCompany: '',
      enterpriseCode: '',
      enterpriseName: '',
      enterpriseOrder: '',
      num: '',
      item: '',
      isParceldetail: {
        isParcelUnpack: false,
        text: '',
      },
      parcelUnpack: true,
      id: '',
      isactive: false,
      parcelType: '',
      excom: '根據快遞單號自動識別'
    }
  },
  activated() {
    Toast.loading('加載中...')
    this.$route.query.item ? this.id = JSON.parse(this.$route.query.item).id : this.id = ''
    this.$route.query.item ? this.item = JSON.parse(this.$route.query.item) : this.item = ''
    eventBus.$on('goodeNameinfo', function (data, index) {
      if (this.$refs.modal != undefined && data) {
        this.isactive = true
        this.$refs.modal.list[index].name = data
      } else {
        this.isactive = false
      }
    }.bind(this))
    eventBus.$on('goodeUrlinfo', function (data, index) {
      this.isactive = true
      if (this.$refs.modal != undefined && data) {
        this.$set(this.$refs.modal.list[index], 'url', data)
      } else {
        this.isactive = false
      }

    }.bind(this))
    eventBus.$on('setEnterprise', function (data, index) {
      this.isactive = true
      if (this.$refs.modal != undefined && data) {
        console.log('enterpriseName', data)
        this.$set(this, 'enterpriseCode', data.enterpriseCode)
        this.$set(this, 'enterpriseName', data.enterpriseName)
      } else {
        this.isactive = false
      }

    }.bind(this))
    JSON.parse(localStorage.getItem('userinfoMobie')).disVo.code == 'NZ' ? this.show = true : this.show = false
    console.log(this.isactive)
    this.item ? this.onloadhouse() : this.getwarhouse()
  },
  methods: {
    handNoewe() {
      this.$router.push({
        name: 'EnterpriseModal',
      })
    },
    onloadhouse() {

      if (this.isactive) {
        Toast.hide()
        return
      }
      const par = {
        id: this.item.id
      }
      this.http.APIASK(this.ports.arcel, 'get', par).then(res => {
        console.log(res)
        this.getwhous(res.countryId, null)
        if (res.isSpecialGoods && res.isSpecialGoods > 0) {
          this.favorites = ['apple']
        } else {
          this.favorites = []
        }
        this.num = this.item.expressNumber
        this.remark = this.item.remark
        this.item.enterpriseCode ? this.enterpriseCode = this.item.enterpriseCode : this.enterpriseCode = ''
        this.item.enterpriseName ? this.enterpriseName = this.item.enterpriseName : this.enterpriseName = ''
        this.item.enterpriseOrder ? this.enterpriseOrder = this.item.enterpriseOrder : this.enterpriseOrder = ''
        this.item.isParcelUnpack === null ? this.parcelUnpack = true : this.parcelUnpack = this.item.isParcelUnpack
        this.expressCompany = this.item.expressCompany
        this.expressCompany ? this.excom = this.expressCompany : this.excom = '根據快遞單號自動識別'
        var thant = this
        setTimeout(function () {
          thant.$refs.modal.list = res.list
          thant.$refs.modal.allprice = res.totalPrice
        }, 10)
        this.parcelType = this.options[res.type].label
        this.getParch(res.countryId)
        Toast.hide()
        thant.addshow = true
      }).catch(err => {
        Toast.hide()
        this.addshow = true
      })
    },
    delet(e) {
      this.list[e].id ? this.parcel(this.list[e].id) : null
      this.list.splice(e, 1)
      this.getAllvalue()
    },
    addshop() {
      const item = {
        id: '',
        name: '',
        num: 1,
        price: '',
        url: ''
      }
      this.list.push(item)
    },
    getname(index) {
      this.$router.push({
        name: 'Goodname',
        query: {
          index: index
        }
      })
    },
    getAllvalue() {
      var price = this.sum(this.list)
      this.allprice = price.toFixed(2)
    },
    submitform() {
      if (!this.num) {
        Toast.failed('請輸入快遞單號')
        return
      }
      if (this.parceDetaik.isParcelType && !this.parcelType) {
        Toast.failed('請选择货物类型')
        return
      }
      this.submit()
    },
    $_selected(item) {
      this.parcelType = item.label
      console.log('action-sheet selected:', JSON.stringify(item))
    },

    $_selectedtwo(item) {
      if (!item.value) {
        Dialog.confirm({
          title: '提示',
          content: this.isParceldetail.text,
          cancelText: '取消',
          confirmText: '确定',
          onConfirm: () => {
            this.parcelUnpack = false
          },
          onCancel: () => {
            this.parcelUnpack = true
          }
        })
      } else {
        this.parcelUnpack = item.value
      }
      // this.parcelType=item.label
      // console.log('action-sheet selected:', JSON.stringify(item))
    },

    submit() {
      const par = {
        expressCompany: this.expressCompany,
        expressNumber: this.num,
        id: this.id,
        isParcelUnpack: this.isParceldetail.isParcelUnpack ? this.parcelUnpack : null,
        remark: this.remark,
        parcelType: this.parcelType,
        enterpriseCode: this.enterpriseCode,
        enterpriseName: this.enterpriseName,
        enterpriseOrder: this.enterpriseOrder,
        isSpecialGoods: this.favorites.length,
        products: this.$refs.modal.list,
        wareHouseId: this.$route.query.id,

      }
      this.http.APIASK(this.ports.parceladd, 'post', par).then(res => {
        this.isactive = false
        this.addshow = false
        localStorage.setItem('fleshpack', '11')
        this.id ? this.$router.go(-1) : this.$router.replace({name: 'Package'})
      }).catch(err => {
      })
    },
    sum(arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += (val.price * val.num)
      }, 0)
      return s
    },
    parcel(id) {
      const par = {
        productId: id
      }
      this.http.APIASK(this.ports.deleteProduct, 'delet', par).then(res => {
      }).catch(err => {

      })
    },
    getParch(countryId) {
      this.http.APIASK(this.ports.isParcelType, 'get', {countryId}).then(resut => {
        this.parceDetaik = resut

      })
      this.isParcelType(countryId)
    },
    isParcelType(countryId) {
      this.http.APIASK(this.ports.isParcelUnpack, 'get', {countryId}).then(resut => {
        this.isParceldetail = resut

      })
    },
    cheurusner() {
      if (!this.parcelUnpack) {
        Dialog.confirm({
          title: '提示',
          content: this.isParceldetail.text,
          cancelText: '取消',
          confirmText: '确定',
          onConfirm: () => {
            this.parcelUnpack = false
          },
          onCancel: () => {
            this.parcelUnpack = true
          }
        })
      }
    },
    getwarhouse() {
      this.getParch(this.$route.query.id)
      this.http.APIASK(this.ports.getWareHouse, 'get').then(res => {
        if (this.isactive) {
          Toast.hide()
          return
        }
        this.num = ''
        this.expressCompany = ''
        this.expressCompany ? this.excom = this.expressCompany : this.excom = '根據快遞單號自動識別'
        // this.whouse = res[0].name+' '+' '+'['+JSON.parse(localStorage.getItem('userinfoMobie')).disVo.name+']'
        this.whouse = JSON.parse(localStorage.getItem('userinfoMobie')).disVo.name
        this.getwhous(this.$route.query.id, null)
        var thant = this
        setTimeout(function () {
          thant.$refs.modal.list = [{
            id: '',
            name: '',
            num: 1,
            price: ''
          }]
          thant.$refs.modal.allprice = 0.00
        }, 10)
        thant.addshow = true
        Toast.hide()
      }).catch(err => {
        this.addshow = true
        Toast.hide()
      })
    },
    getwhous(id, warehouseName) {
      console.log(JSON.parse(localStorage.getItem('countryList')))
      var findevalue = JSON.parse(localStorage.getItem('countryList')).find(val => {
        return val.id == id
      })
      console.log('findevalue', findevalue)
      warehouseName ? this.whouse = warehouseName + ' ' + ' ' + '[' + findevalue.name + ']' : null
      this.conuntrycode = findevalue
      findevalue.code == 'NZ' ? this.show = true : this.show = false
      var thant = this
      setTimeout(function () {
        thant.$refs.modal.conuntrycode = findevalue
      }, 10)
      console.log(id)
    },
    queryLogisticsNameInfo() {
      if (!this.num) {
        return
      }
      this.num = this.num.replace(/\s+/g, "");
      const par = {
        num: this.num
      }
    }
  },
  mounted() {

  }
}
</script>

<style lang="less">
.container {
  margin: 0 0.4rem;
  background-color: #ffeeef;
  color: #ff5b60;
  font-size: 0.26rem;
  position: relative;

  p {
    padding: 0.25rem 0.4rem;
    text-align: left;
  }

  .icone {
    position: absolute;
    right: 0.1rem;
  }
}

.md-field-content {
  background-color: white;
  border-radius: 0.1rem;
}

.md-field-item-content:before {
  content: "";
  position: absolute;
  z-index: 2;
  -webkit-transform: scaleY(.5) translateY(100%);
  transform: scaleY(.5) translateY(100%);
  bottom: 0;
  left: 0;
  right: auto;
  top: auto;
  width: 100%;
  border-bottom: 0.02rem solid #e2e4ea;
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
}

.fils {
  width: 100%;
  padding: 0.2rem;
  color: #ff5b60;
  height: auto;
  position: fixed;
  bottom: 1rem;
  font-size: 0.24rem;
  text-align: left;
  background-color: #ffffff;

  .md-cell-item-body {
    padding: 0.2rem 0;
  }
}

.ndnenr .md-field-item-content:before {
  border-bottom: none !important;
}

.ndnenrdata .md-field-item-title {
  width: 2.7rem !important;
}
</style>
